/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { CredentialClaimLinkedCredentialValue } from './CredentialClaimLinkedCredentialValue';

export const LinkClaimValue: core.serialization.ObjectSchema<serializers.LinkClaimValue.Raw, Truvity.LinkClaimValue> =
    core.serialization.object({
        value: CredentialClaimLinkedCredentialValue,
    });

export declare namespace LinkClaimValue {
    export interface Raw {
        value: CredentialClaimLinkedCredentialValue.Raw;
    }
}
